import burger from '../src/image/bur.jpg';
import pizza from '../src/image/pizza.jpg';
import momo from '../src/image/mo.jpg';
import chicken from '../src/image/ck.jpg';
import ice from '../src/image/ice.jpg';
import cake from '../src/image/cake.jpg';

const Sdata = [
    {
        imgsrc: burger,
        title:"Burger",
    },
    {
        imgsrc :ice,
        title:"Ice-cream",
    },
    {
        imgsrc: pizza,
        title:"Pizza",
    },
    {
        imgsrc: chicken,
        title:"Chicken",
    },
    {
        imgsrc: momo,
        title:"Momo",
    },
    
    {
        imgsrc: cake,
        title:"Cake",
    }
]
export default Sdata;